import { render, staticRenderFns } from "./AcceleratorMaster.vue?vue&type=template&id=a65c17b8&"
import script from "./AcceleratorMaster.vue?vue&type=script&lang=js&"
export * from "./AcceleratorMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports